import { render, staticRenderFns } from "./ChildSelector.vue?vue&type=template&id=19f226f2&scoped=true"
import script from "./ChildSelector.vue?vue&type=script&lang=js"
export * from "./ChildSelector.vue?vue&type=script&lang=js"
import style0 from "./ChildSelector.vue?vue&type=style&index=0&id=19f226f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f226f2",
  null
  
)

export default component.exports